import React from "react";
import {
	FormControl,
	InputLabel,
	Select as MuiSelect,
	MenuItem,
	Box,
} from "@mui/material";

export default function Select(props) {
	const { style, name, label, value, onChange, options } = props;

	return (
		// <FormControl variant='outlined'>
		// 	<InputLabel>{label}</InputLabel>
		// 	<MuiSelect
		// 		sx={style}
		// 		label={label}
		// 		name={name}
		// 		value={value}
		// 		onChange={onChange}>
		// 		<MenuItem value=''>None</MenuItem>
		// 		{options.map((item) => (
		// 			<MenuItem key={item.id} value={item.id}>
		// 				{item.title}
		// 			</MenuItem>
		// 		))}
		// 	</MuiSelect>
		// </FormControl>
		<Box>
			<FormControl sx={{ minWidth: 350, ml: 7, mt: 4 }}>
				<InputLabel>{label}</InputLabel>
				<MuiSelect
					style={style}
					name={name}
					label={label}
					value={value}
					onChange={onChange}>
					<MenuItem value=' '>None</MenuItem>
					{options.map((item) => (
						<MenuItem key={item.id} value={item.id}>
							{item.name}
						</MenuItem>
					))}
				</MuiSelect>
			</FormControl>
		</Box>
	);
}
